import { TitleDivider } from './title-divider';

const CustomDivider = {
    Title: TitleDivider,

    name: ''
};

export default CustomDivider;
